<a
	*ngIf="showDownloadIcon && currentPath === key && key != 'overview'"
	href="javascript:void(0)"
	(click)="downloadDataInCSV($event)"
	target="_blank"
>
	<i class="fa fa-download" aria-hidden="true"></i
></a>

<a
	*ngIf="showProductDownloadIcon && key != 'overview'"
	href="javascript:void(0)"
	class="product_csv_download_icon"
	(click)="downloadProductDataXLSX($event)"
>
	<i *ngIf="!disabledDownloadButton && !(isR102 || isR103 || isR1301 || isR104)" class="productDownloadIcon">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="46"
			height="46"
			viewBox="0 -2 38 38"
			preserveAspectRatio="xMidYMid meet"
			class="enabled-download-icon"
		>
			<g fill-rule="evenodd">
				<circle class="download-button" cx="18" cy="18" r="14" fill="#fff"></circle>
				<path
					class="arrow-icon-2"
					fill-rule="nonzero"
					d="M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5z"
				></path>
				<path
					class="arrow-icon"
					d="M11 24H25V26H11zM17.036 7.207h2l-.001 11.242 4.657-4.656 1.415 1.414-6.364 6.364c-.39.39-1.024.39-1.415 0l-6.364-6.364 1.415-1.414 4.656 4.656V7.207z"
				></path>
			</g>
		</svg>
	</i>

	<i *ngIf="!disabledDownloadButton && isR1301" style="display: none" class="r1301productDownloadIcon">
		<svg
			width="24"
			height="24"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="enabled-download-icon"
			tooltip="Download Product Data"
			tooltip-class="download-tooltip"
			placement="top"
		>
			<path
				class="page-title-color"
				d="M15.1274 0.872594C14.5647 0.309906 13.8166 3.125e-05 13.0208 6.25e-05L2.97919 0C1.33644 6.25e-05 0 1.33653 0 2.97916V13.0208C0 14.6635 1.3365 16 2.97919 16H13.0208C14.6635 16 16 14.6635 16 13.0208V2.97922C16 2.18344 15.6901 1.43528 15.1274 0.872594ZM5.18328 6.79669C5.36631 6.61366 5.66309 6.61366 5.84619 6.79669L7.53125 8.48175L7.53119 3.48122C7.53119 3.22234 7.74106 3.01247 7.99994 3.01247C8.25884 3.01247 8.46869 3.22234 8.46869 3.48122L8.46875 8.48162L10.1537 6.79663C10.3367 6.61359 10.6335 6.61359 10.8166 6.79663C10.9997 6.97966 10.9997 7.27647 10.8166 7.45953L8.33144 9.94478C8.2435 10.0327 8.12428 10.0821 7.99997 10.0821C7.87569 10.0821 7.75644 10.0327 7.66856 9.94478L5.18334 7.45959C5.00022 7.27656 5.00022 6.97975 5.18328 6.79669ZM12.5188 12.9875H3.48125C3.22241 12.9875 3.0125 12.7776 3.0125 12.5188C3.0125 12.2599 3.22241 12.05 3.48125 12.05H12.5188C12.7776 12.05 12.9875 12.2599 12.9875 12.5188C12.9876 12.7776 12.7777 12.9875 12.5188 12.9875Z"
			/>
		</svg>
	</i>

	<span *ngIf="!disabledDownloadButton && (isR102 || isR103 || isR104)" class="r102-product-downloads">
		Product Downloads
		<svg
			*ngIf="(isR102 || isR104) && !isR2"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.75 0.75C6.75 0.335156 6.41484 0 6 0C5.58516 0 5.25 0.335156 5.25 0.75V6.43828L3.52969 4.71797C3.23672 4.425 2.76094 4.425 2.46797 4.71797C2.175 5.01094 2.175 5.48672 2.46797 5.77969L5.46797 8.77969C5.76094 9.07266 6.23672 9.07266 6.52969 8.77969L9.52969 5.77969C9.82266 5.48672 9.82266 5.01094 9.52969 4.71797C9.23672 4.425 8.76094 4.425 8.46797 4.71797L6.75 6.43828V0.75ZM1.5 8.25C0.672656 8.25 0 8.92266 0 9.75V10.5C0 11.3273 0.672656 12 1.5 12H10.5C11.3273 12 12 11.3273 12 10.5V9.75C12 8.92266 11.3273 8.25 10.5 8.25H8.12109L7.05938 9.31172C6.47344 9.89766 5.52422 9.89766 4.93828 9.31172L3.87891 8.25H1.5ZM10.125 9.5625C10.2742 9.5625 10.4173 9.62176 10.5227 9.72725C10.6282 9.83274 10.6875 9.97582 10.6875 10.125C10.6875 10.2742 10.6282 10.4173 10.5227 10.5227C10.4173 10.6282 10.2742 10.6875 10.125 10.6875C9.97582 10.6875 9.83274 10.6282 9.72725 10.5227C9.62176 10.4173 9.5625 10.2742 9.5625 10.125C9.5625 9.97582 9.62176 9.83274 9.72725 9.72725C9.83274 9.62176 9.97582 9.5625 10.125 9.5625Z"
				fill="#434342"
			/>
		</svg>
		<i *ngIf="isR102 && isR2" _ngcontent-bvr-c54="" aria-hidden="true" class="fa fa-download"></i>
	</span>

	<i
		*ngIf="disabledDownloadButton && !(isR102 || isR103 || isR1301 || isR104)"
		aria-hidden="true"
		class="productDownloadIcon"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="46"
			height="46"
			viewBox="0 -2 38 38"
			preserveAspectRatio="xMidYMid meet"
			class="disabled-download-icon"
		>
			<g fill-rule="evenodd">
				<path
					fill-rule="nonzero"
					d="M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5z"
				/>
				<path
					d="M11 24H25V26H11zM17.036 7.207h2l-.001 11.242 4.657-4.656 1.415 1.414-6.364 6.364c-.39.39-1.024.39-1.415 0l-6.364-6.364 1.415-1.414 4.656 4.656V7.207z"
				/>
			</g>
		</svg>
	</i>

	<i
		*ngIf="disabledDownloadButton && isR1301"
		aria-hidden="true"
		style="display: none"
		class="r1301productDownloadIcon"
	>
		<svg
			width="24"
			height="24"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="disabled-download-icon"
		>
			<path
				d="M15.1274 0.872594C14.5647 0.309906 13.8166 3.125e-05 13.0208 6.25e-05L2.97919 0C1.33644 6.25e-05 0 1.33653 0 2.97916V13.0208C0 14.6635 1.3365 16 2.97919 16H13.0208C14.6635 16 16 14.6635 16 13.0208V2.97922C16 2.18344 15.6901 1.43528 15.1274 0.872594ZM5.18328 6.79669C5.36631 6.61366 5.66309 6.61366 5.84619 6.79669L7.53125 8.48175L7.53119 3.48122C7.53119 3.22234 7.74106 3.01247 7.99994 3.01247C8.25884 3.01247 8.46869 3.22234 8.46869 3.48122L8.46875 8.48162L10.1537 6.79663C10.3367 6.61359 10.6335 6.61359 10.8166 6.79663C10.9997 6.97966 10.9997 7.27647 10.8166 7.45953L8.33144 9.94478C8.2435 10.0327 8.12428 10.0821 7.99997 10.0821C7.87569 10.0821 7.75644 10.0327 7.66856 9.94478L5.18334 7.45959C5.00022 7.27656 5.00022 6.97975 5.18328 6.79669ZM12.5188 12.9875H3.48125C3.22241 12.9875 3.0125 12.7776 3.0125 12.5188C3.0125 12.2599 3.22241 12.05 3.48125 12.05H12.5188C12.7776 12.05 12.9875 12.2599 12.9875 12.5188C12.9876 12.7776 12.7777 12.9875 12.5188 12.9875Z"
			/>
		</svg>
	</i>
	<span *ngIf="disabledDownloadButton && (isR102 || isR103 || isR104)" class="r102-product-downloads disabled-button">
		Product Downloads
		<svg
			*ngIf="(isR102 || isR104) && !isR2"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.75 0.75C6.75 0.335156 6.41484 0 6 0C5.58516 0 5.25 0.335156 5.25 0.75V6.43828L3.52969 4.71797C3.23672 4.425 2.76094 4.425 2.46797 4.71797C2.175 5.01094 2.175 5.48672 2.46797 5.77969L5.46797 8.77969C5.76094 9.07266 6.23672 9.07266 6.52969 8.77969L9.52969 5.77969C9.82266 5.48672 9.82266 5.01094 9.52969 4.71797C9.23672 4.425 8.76094 4.425 8.46797 4.71797L6.75 6.43828V0.75ZM1.5 8.25C0.672656 8.25 0 8.92266 0 9.75V10.5C0 11.3273 0.672656 12 1.5 12H10.5C11.3273 12 12 11.3273 12 10.5V9.75C12 8.92266 11.3273 8.25 10.5 8.25H8.12109L7.05938 9.31172C6.47344 9.89766 5.52422 9.89766 4.93828 9.31172L3.87891 8.25H1.5ZM10.125 9.5625C10.2742 9.5625 10.4173 9.62176 10.5227 9.72725C10.6282 9.83274 10.6875 9.97582 10.6875 10.125C10.6875 10.2742 10.6282 10.4173 10.5227 10.5227C10.4173 10.6282 10.2742 10.6875 10.125 10.6875C9.97582 10.6875 9.83274 10.6282 9.72725 10.5227C9.62176 10.4173 9.5625 10.2742 9.5625 10.125C9.5625 9.97582 9.62176 9.83274 9.72725 9.72725C9.83274 9.62176 9.97582 9.5625 10.125 9.5625Z"
				fill="#ccc"
			/>
		</svg>
		<i *ngIf="isR102 && isR2" _ngcontent-bvr-c54="" aria-hidden="true" class="fa fa-download"></i>
	</span>
</a>

<a
	*ngIf="hasOverviewCSVPermission && key == 'overview'"
	href="javascript:void(0)"
	class="product_csv_download_icon"
	tooltip="{{ overviewToolTipMsg }}"
	tooltip-class="printable-tooltip"
	placement="top"
	(click)="downloadProductDataXLSX($event)"
	[ngClass]="{ showOverviewDownloadIcon: showDownloadIcon, hideOverviewDownloadIcon: !showDownloadIcon }"
>
	<i
		*ngIf="!overviewDisabledDownloadButton && showDownloadIcon && !(isR102 || isR103 || isR1301 || isR104)"
		class="productDownloadIcon"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="46"
			height="46"
			viewBox="0 -2 38 38"
			preserveAspectRatio="xMidYMid meet"
			class="enabled-download-icon"
		>
			<g fill-rule="evenodd">
				<circle class="download-button" cx="18" cy="18" r="14" fill="#fff"></circle>
				<path
					class="arrow-icon-2"
					fill-rule="nonzero"
					d="M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5z"
				></path>
				<path
					class="arrow-icon"
					d="M11 24H25V26H11zM17.036 7.207h2l-.001 11.242 4.657-4.656 1.415 1.414-6.364 6.364c-.39.39-1.024.39-1.415 0l-6.364-6.364 1.415-1.414 4.656 4.656V7.207z"
				></path>
			</g>
		</svg>
	</i>

	<i *ngIf="!overviewDisabledDownloadButton && isR1301" style="display: none" class="r1301productDownloadIcon">
		<svg
			width="24"
			height="24"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="enabled-download-icon"
			tooltip="Download Product Data"
			tooltip-class="download-tooltip"
			placement="top"
		>
			<path
				class="page-title-color"
				d="M15.1274 0.872594C14.5647 0.309906 13.8166 3.125e-05 13.0208 6.25e-05L2.97919 0C1.33644 6.25e-05 0 1.33653 0 2.97916V13.0208C0 14.6635 1.3365 16 2.97919 16H13.0208C14.6635 16 16 14.6635 16 13.0208V2.97922C16 2.18344 15.6901 1.43528 15.1274 0.872594ZM5.18328 6.79669C5.36631 6.61366 5.66309 6.61366 5.84619 6.79669L7.53125 8.48175L7.53119 3.48122C7.53119 3.22234 7.74106 3.01247 7.99994 3.01247C8.25884 3.01247 8.46869 3.22234 8.46869 3.48122L8.46875 8.48162L10.1537 6.79663C10.3367 6.61359 10.6335 6.61359 10.8166 6.79663C10.9997 6.97966 10.9997 7.27647 10.8166 7.45953L8.33144 9.94478C8.2435 10.0327 8.12428 10.0821 7.99997 10.0821C7.87569 10.0821 7.75644 10.0327 7.66856 9.94478L5.18334 7.45959C5.00022 7.27656 5.00022 6.97975 5.18328 6.79669ZM12.5188 12.9875H3.48125C3.22241 12.9875 3.0125 12.7776 3.0125 12.5188C3.0125 12.2599 3.22241 12.05 3.48125 12.05H12.5188C12.7776 12.05 12.9875 12.2599 12.9875 12.5188C12.9876 12.7776 12.7777 12.9875 12.5188 12.9875Z"
			/>
		</svg>
	</i>
	<span *ngIf="!overviewDisabledDownloadButton && (isR102 || isR103 || isR104)" class="r102-product-downloads">
		Product Downloads
		<svg
			*ngIf="(isR102 || isR104) && !isR2"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.75 0.75C6.75 0.335156 6.41484 0 6 0C5.58516 0 5.25 0.335156 5.25 0.75V6.43828L3.52969 4.71797C3.23672 4.425 2.76094 4.425 2.46797 4.71797C2.175 5.01094 2.175 5.48672 2.46797 5.77969L5.46797 8.77969C5.76094 9.07266 6.23672 9.07266 6.52969 8.77969L9.52969 5.77969C9.82266 5.48672 9.82266 5.01094 9.52969 4.71797C9.23672 4.425 8.76094 4.425 8.46797 4.71797L6.75 6.43828V0.75ZM1.5 8.25C0.672656 8.25 0 8.92266 0 9.75V10.5C0 11.3273 0.672656 12 1.5 12H10.5C11.3273 12 12 11.3273 12 10.5V9.75C12 8.92266 11.3273 8.25 10.5 8.25H8.12109L7.05938 9.31172C6.47344 9.89766 5.52422 9.89766 4.93828 9.31172L3.87891 8.25H1.5ZM10.125 9.5625C10.2742 9.5625 10.4173 9.62176 10.5227 9.72725C10.6282 9.83274 10.6875 9.97582 10.6875 10.125C10.6875 10.2742 10.6282 10.4173 10.5227 10.5227C10.4173 10.6282 10.2742 10.6875 10.125 10.6875C9.97582 10.6875 9.83274 10.6282 9.72725 10.5227C9.62176 10.4173 9.5625 10.2742 9.5625 10.125C9.5625 9.97582 9.62176 9.83274 9.72725 9.72725C9.83274 9.62176 9.97582 9.5625 10.125 9.5625Z"
				fill="#434342"
			/>
		</svg>
		<i *ngIf="isR102 && isR2" _ngcontent-bvr-c54="" aria-hidden="true" class="fa fa-download"></i>
	</span>

	<i
		*ngIf="overviewDisabledDownloadButton && !showDownloadIcon && !(isR102 || isR103 || isR1301 || isR104)"
		aria-hidden="true"
		class="productDownloadIcon disabled_download_icon"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="46"
			height="46"
			viewBox="0 -2 38 38"
			preserveAspectRatio="xMidYMid meet"
			class="disabled-download-icon"
		>
			<g fill-rule="evenodd">
				<path
					fill-rule="nonzero"
					d="M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5z"
				/>
				<path
					d="M11 24H25V26H11zM17.036 7.207h2l-.001 11.242 4.657-4.656 1.415 1.414-6.364 6.364c-.39.39-1.024.39-1.415 0l-6.364-6.364 1.415-1.414 4.656 4.656V7.207z"
				/>
			</g>
		</svg>
	</i>

	<i
		*ngIf="overviewDisabledDownloadButton && isR1301"
		aria-hidden="true"
		style="display: none"
		class="r1301productDownloadIcon disabled_download_icon"
	>
		<svg
			width="24"
			height="24"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="disabled-download-icon"
		>
			<path
				d="M15.1274 0.872594C14.5647 0.309906 13.8166 3.125e-05 13.0208 6.25e-05L2.97919 0C1.33644 6.25e-05 0 1.33653 0 2.97916V13.0208C0 14.6635 1.3365 16 2.97919 16H13.0208C14.6635 16 16 14.6635 16 13.0208V2.97922C16 2.18344 15.6901 1.43528 15.1274 0.872594ZM5.18328 6.79669C5.36631 6.61366 5.66309 6.61366 5.84619 6.79669L7.53125 8.48175L7.53119 3.48122C7.53119 3.22234 7.74106 3.01247 7.99994 3.01247C8.25884 3.01247 8.46869 3.22234 8.46869 3.48122L8.46875 8.48162L10.1537 6.79663C10.3367 6.61359 10.6335 6.61359 10.8166 6.79663C10.9997 6.97966 10.9997 7.27647 10.8166 7.45953L8.33144 9.94478C8.2435 10.0327 8.12428 10.0821 7.99997 10.0821C7.87569 10.0821 7.75644 10.0327 7.66856 9.94478L5.18334 7.45959C5.00022 7.27656 5.00022 6.97975 5.18328 6.79669ZM12.5188 12.9875H3.48125C3.22241 12.9875 3.0125 12.7776 3.0125 12.5188C3.0125 12.2599 3.22241 12.05 3.48125 12.05H12.5188C12.7776 12.05 12.9875 12.2599 12.9875 12.5188C12.9876 12.7776 12.7777 12.9875 12.5188 12.9875Z"
			/>
		</svg>
	</i>
	<span
		*ngIf="overviewDisabledDownloadButton && (isR102 || isR103 || isR104)"
		class="r102-product-downloads disabled-button"
	>
		Product Downloads
		<svg
			*ngIf="(isR102 || isR104) && !isR2"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.75 0.75C6.75 0.335156 6.41484 0 6 0C5.58516 0 5.25 0.335156 5.25 0.75V6.43828L3.52969 4.71797C3.23672 4.425 2.76094 4.425 2.46797 4.71797C2.175 5.01094 2.175 5.48672 2.46797 5.77969L5.46797 8.77969C5.76094 9.07266 6.23672 9.07266 6.52969 8.77969L9.52969 5.77969C9.82266 5.48672 9.82266 5.01094 9.52969 4.71797C9.23672 4.425 8.76094 4.425 8.46797 4.71797L6.75 6.43828V0.75ZM1.5 8.25C0.672656 8.25 0 8.92266 0 9.75V10.5C0 11.3273 0.672656 12 1.5 12H10.5C11.3273 12 12 11.3273 12 10.5V9.75C12 8.92266 11.3273 8.25 10.5 8.25H8.12109L7.05938 9.31172C6.47344 9.89766 5.52422 9.89766 4.93828 9.31172L3.87891 8.25H1.5ZM10.125 9.5625C10.2742 9.5625 10.4173 9.62176 10.5227 9.72725C10.6282 9.83274 10.6875 9.97582 10.6875 10.125C10.6875 10.2742 10.6282 10.4173 10.5227 10.5227C10.4173 10.6282 10.2742 10.6875 10.125 10.6875C9.97582 10.6875 9.83274 10.6282 9.72725 10.5227C9.62176 10.4173 9.5625 10.2742 9.5625 10.125C9.5625 9.97582 9.62176 9.83274 9.72725 9.72725C9.83274 9.62176 9.97582 9.5625 10.125 9.5625Z"
				fill="#ccc"
			/>
		</svg>
		<i *ngIf="isR102 && isR2" _ngcontent-bvr-c54="" aria-hidden="true" class="fa fa-download"></i>
	</span>
</a>
